import { StrapiFilters, StrapiGetListParameters } from '@core/const';

export function parametersWithCityFilterFactory<TAttributes extends object>({
  fieldNameCityIncluded,
  fieldNameCityExcluded,
  baseStoreCode,
  allBaseStoreCodes,
  filters,
}: {
  fieldNameCityIncluded: keyof TAttributes;
  fieldNameCityExcluded?: keyof TAttributes;
  baseStoreCode: string;
  allBaseStoreCodes: string[];
  filters?: StrapiFilters<TAttributes>;
}): StrapiGetListParameters<TAttributes> {
  const filtersWithCityIncluded: StrapiFilters<TAttributes> = {
    [fieldNameCityIncluded]: {
      $or: [
        {
          code: {
            $eq: baseStoreCode,
          },
        },
        {
          code: {
            $null: true,
          },
        },
      ],
    },
  };

  let filtersWithCityExcluded: StrapiFilters<TAttributes> = {};

  if (fieldNameCityExcluded) {
    filtersWithCityExcluded = {
      [fieldNameCityExcluded]: {
        $or: [
          {
            code: {
              $in: allBaseStoreCodes.filter((code) => code !== baseStoreCode),
            },
          },
          {
            code: {
              $null: true,
            },
          },
        ],
      },
    };
  }

  return {
    filters: { ...filtersWithCityIncluded, ...filtersWithCityExcluded, ...(filters || {}) },
    sort: [`${fieldNameCityIncluded as string}.name:asc`],
  };
}
